import { useState, useMemo } from 'react';
import SEO from '../../components/SEO';
import AdUnit from '../../components/AdUnit';

function analyze(text) {
  var chars = text.length;
  var charsNoSpaces = text.replace(/\s/g, '').length;
  var words = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
  var sentences = text.trim() === '' ? 0 : text.split(/[.!?]+/).filter(function (s) { return s.trim().length > 0; }).length;
  var paragraphs = text.trim() === '' ? 0 : text.split(/\n\s*\n/).filter(function (s) { return s.trim().length > 0; }).length;
  var readingTime = Math.max(1, Math.ceil(words / 200));
  var speakingTime = Math.max(1, Math.ceil(words / 130));
  return { chars: chars, charsNoSpaces: charsNoSpaces, words: words, sentences: sentences, paragraphs: paragraphs, readingTime: readingTime, speakingTime: speakingTime };
}

function WordCounter() {
  const [text, setText] = useState('');
  var stats = useMemo(function () { return analyze(text); }, [text]);

  return (
    <div className="page-prettifier">
      <SEO title="Word Counter - Count Words, Characters & Sentences" description="Free online word counter. Count words, characters, sentences, paragraphs, and estimate reading time. Perfect for essays, social media, and more." path="/word-counter" />
      <div className="container">
        <div className="tool-header">
          <h1>Word Counter</h1>
          <p>Paste or type your text below to instantly count words, characters, sentences, and more.</p>
        </div>
        <AdUnit />
        <div className="stats-grid">
          <div className="stat-card"><div className="stat-number">{stats.words}</div><div className="stat-label">Words</div></div>
          <div className="stat-card"><div className="stat-number">{stats.chars}</div><div className="stat-label">Characters</div></div>
          <div className="stat-card"><div className="stat-number">{stats.charsNoSpaces}</div><div className="stat-label">No Spaces</div></div>
          <div className="stat-card"><div className="stat-number">{stats.sentences}</div><div className="stat-label">Sentences</div></div>
          <div className="stat-card"><div className="stat-number">{stats.paragraphs}</div><div className="stat-label">Paragraphs</div></div>
          <div className="stat-card"><div className="stat-number">{stats.readingTime}m</div><div className="stat-label">Reading Time</div></div>
          <div className="stat-card"><div className="stat-number">{stats.speakingTime}m</div><div className="stat-label">Speaking Time</div></div>
        </div>
        <div className="editor-pane" style={{ marginTop: '1rem' }}>
          <div className="pane-header"><span>Your Text</span><button className="copy-btn" type="button" onClick={function () { setText(''); }}>Clear</button></div>
          <textarea className="editor-textarea" value={text} onChange={function (e) { setText(e.target.value); }} placeholder="Start typing or paste your text here..." spellCheck={false} aria-label="Text input" style={{ minHeight: '300px' }} />
        </div>
        <section className="tool-guide">
          <h2>Why Count Words?</h2>
          <p>Word counts matter more than you think. Social media platforms have character limits (Twitter/X: 280 characters, Instagram bio: 150). College essays and job applications often require specific word counts. Bloggers and content creators track word count to maintain consistency. This tool gives you all the numbers in real time as you type.</p>
          <h2>Common Limits</h2>
          <ul>
            <li>Twitter/X post: 280 characters</li>
            <li>Instagram bio: 150 characters</li>
            <li>LinkedIn summary: 2,600 characters</li>
            <li>College essay (Common App): 250-650 words</li>
            <li>Google meta description: 155-160 characters</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default WordCounter;
